import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ArrowDownIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M13.25 5.25v10.17l4.308-4.308a1.25 1.25 0 1 1 1.769 1.768L12 20.207 4.674 12.88a1.25 1.25 0 1 1 1.768-1.768l4.308 4.308V5.25a1.25 1.25 0 0 1 2.5 0" />
    </Icon>
  );
}

ArrowDownIcon.displayName = 'ArrowDownIcon';
